export interface IndexedDbKeys {
  workspace: string;
  [key: string]: string;
}

export const indexedDbKeys: IndexedDbKeys = {
  workspace: 'manage-workspaces-content',
  sentryUrl: 'https://1f4347b96ff1463f995df355e8791e88@o274145.ingest.sentry.io/5435445',
};
